import { addDays, dataDate, dateFormatData } from 'features/dates/date-helpers';

/**
 * Calculate shoulder rooms from stay overs
 * 6-20-25 does not seem to be used in the codebase, but is included for completeness. ~ Chad
 */
export const calculateShoulderRoomsFromStayOver = (
	transientFcst: number,
	checkInDate: string,
	checkOutDate: string,
	stayDate: string,
	roomsDisplaced: number,
	priorStayOvers: number,
	postStayOvers: number,
) => {
	const checkIn = dataDate(checkInDate);
	const checkOut = dataDate(checkOutDate);
	const stay = dataDate(stayDate);

	const priorStayOverRatio = priorStayOvers / transientFcst;
	const postStayOverRatio = postStayOvers / transientFcst;

	//If stay date is not check in or day before check out, or roomsDisplaced is 0, return 0
	if (stay !== checkIn || stay !== checkOut || roomsDisplaced === 0) {
		return 0;
	}

	//If stay date is check in and day before check out
	if (
		stay === checkIn &&
		addDays(1, stay).format(dateFormatData) === checkOut
	) {
		return (
			Math.round(roomsDisplaced * priorStayOverRatio) +
			Math.round(roomsDisplaced * postStayOverRatio)
		);
	}

	//If stay date is check in
	if (stay === checkIn) {
		return Math.round(roomsDisplaced * priorStayOverRatio);
	}

	//If stay date is day before check out
	if (addDays(1, stay).format(dateFormatData) === checkOut) {
		return Math.round(roomsDisplaced * postStayOverRatio);
	}

	return 0;
};

/**
 * Calculate shoulder rooms displaced
 */
export const calculateShoulderRoomsDisplaced = (
	roomsDisplaced: number,
	avgStayLength: number,
	checkInDate: string,
	lastDate: string,
	stayDate: string,
) => {
	const checkIn = dataDate(checkInDate);
	const last = dataDate(lastDate);
	const stay = dataDate(stayDate);
	//If stay date is not check in or day before checkout, or roomsDisplaced is 0, return 0
	if ((stay !== checkIn && stay !== last) || roomsDisplaced === 0) {
		return 0;
	}
	//If stay date is check in and day before checkout
	if (stay === checkIn && addDays(1, stay).format(dateFormatData) === last) {
		return Math.round(roomsDisplaced * avgStayLength * 2);
	}
	//If stay date is check in or day before checkout
	if (stay === checkIn || stay === last) {
		return Math.round(roomsDisplaced * avgStayLength);
	}
	return 0;
};

/**
 * Calculate shoulder displacement cost
 */
export const calculateShoulderDisplacementCost = (
	roomsDisplaced: number,
	transientRate: number,
	rate_requested: number,
) => {
	return roomsDisplaced * (transientRate - rate_requested) * -1;
};
